import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../Modal';
import Money from '../money';
import { t } from '../../../modules/infra/i18n';

const ModalTitle = ({ changeAmount }) => (
  <span>
    <span display-if={!changeAmount}>{t('register:payment.change_modal.no_change')}</span>
    <span display-if={changeAmount}>
      {t('register:payment.change_modal.change_due')}
      <span className="u-ml-- u-co-primary" data-automation-id="text:changeAmount">
        <Money>{changeAmount}</Money>
      </span>
    </span>
  </span>
);
ModalTitle.propTypes = { changeAmount: PropTypes.number };
ModalTitle.defaultProps = { changeAmount: 0 };

const ChangeModal = ({ paidAmount, changeAmount, close }) => (
  <Modal title={<ModalTitle changeAmount={changeAmount} />} close={close}>
    <div className="u-ph++ u-pt+ u-mt u-pb+ u-text-center dark-mode-white">
      {t('register:payment.change_modal.client_paid')}
      <span className="u-ml-- u-co-primary u-type--bold" data-automation-id="text:clientPaidAmount">
        <Money>{paidAmount}</Money>
      </span>
      .
      <div>
        <button
          className="c-btn c-btn--medium u-mt+ u-ph+"
          type="button"
          onClick={close}
          data-automation-id="button:OK"
        >
          {t('common:modal.confirm_button')}
        </button>
      </div>
    </div>
  </Modal>
);
ChangeModal.propTypes = {
  paidAmount: PropTypes.number.isRequired,
  close: PropTypes.func.isRequired,
  changeAmount: PropTypes.number,
};
ChangeModal.defaultProps = {
  changeAmount: 0,
};

export default ChangeModal;
